import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../components/hooks/useAuth';
import useDelete from '../../../components/hooks/useDelete';
import { appName, ticketBaseURL } from '../../../configs/api';
import { getTicketStatusesByAttribute } from '../../../services/TicketStatus';
import { upload_CommonFileSupportTicket } from '../../../services/commonFile';
import { post_Incident } from '../../../services/Tickets';
import { post_fileUpload } from '../../../services/FileUpload';
import { format } from 'date-fns';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTheme } from '../../../components/hooks/useTheme';
import { Button } from '@mui/material';
import PleaseWaitPopup from '../../PleaseWaitPopup';
import colorConfigs from '../../../configs/colorConfigs';
import { CustomImagePopup } from '../../../components/common/CustomImagePopup';
import Cookies from 'js-cookie';

const NewSupportTicket = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [fileIndex, setFileIndex] = useState<number>(0);
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [supportTicketData, setSupportTicketData] = useState<any>({
        accountId: 0,
        incidentName: "",
        status: "2",
        requester: "",
        description: "",
        categoryId: 0,
        subcategoryId: 0,
        assignedToUserId: 0,
        assignedToGroupAssignmentId: 0,
        priority: "",
        dueDate: "",
        emailCC: "",
        expectedRevenue: 0,
        groupId: "0",
        appGroupId: "0",
        appName: appName,
        createdAt: "",
        createdBy: "",
        updatedAt: "",
        updatedBy: ""
    });
    const [priorityData, setPriorityData] = useState<any[]>([]);
    const [isDataUploading, setIsDataUploading] = useState<boolean>(false);
    const [attachmentsValue, setAttachmentsValue] = useState<any[]>([]);
    const [key, setKey] = useState<number>(0);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const fileRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        getTicketStatusesByAttribute('Priority')
            .then((res) => {
                const data = res?.data.reverse()
                    ?.map((item: any) => {
                        return {
                            value: item?.id,
                            label: item?.status
                        }
                    });
                setPriorityData(() => data);

                setSupportTicketData({ ...supportTicketData, priority: data?.length > 0 ? data[0]?.value : 0, });
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!isDataUploading) {
            const selectedFiles = e.target.files as FileList;

            if (selectedFiles.length !== 0) {
                saveImageFile(selectedFiles[0]);
                if (fileRef.current) {
                    fileRef.current.value = '';
                    setKey((prevKey) => prevKey + 1);
                }
            }
        }
    };

    const saveImageFile = (imageFile: File) => {
        setIsDataUploading(true);
        const formData = new FormData();
        formData.append("ImageFile", imageFile);

        upload_CommonFileSupportTicket(formData)
            .then(res => {
                setIsDataUploading(false);
                setAttachmentsValue((prevValue) => ([...prevValue, {
                    fileName: res,
                    createdDate: new Date()
                }]));
            })
            .catch(error => console.error(error))
    }

    const viewImage = (index: number) => {
        setImagePopup(true);
        setFileIndex(index)
    }

    const deleteImage = (id: number) => {
        setDeleteData({
            id: 0,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Attachment?`,
            isDelete: (callback: any) => {
                setAttachmentsValue(() => attachmentsValue?.filter((_: any, index: number) => id !== index));
                callback && callback();
            }
        });

        setDeletePopup(true);
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        post_Incident({
            ...supportTicketData,
            status: "2",
            requester: auth?.givenname,
            priority: supportTicketData.priority,
            appName: appName,
            createdAt: new Date().toISOString(),
            createdBy: auth?.givenname,
            updatedAt: new Date().toISOString(),
            updatedBy: auth?.givenname,
            tenantId: tenantId
        }, auth?.id)
            .then((ticketId) => {
                return fileUpload(ticketId);
            })
            .then(() => {
                navigate(-1);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                console.error('Error creating ticket or uploading files:', error);
                setPleaseWaitPopup(false);
            });

    }

    const fileUpload = (ticketId: any) => {
        return new Promise<void>((resolve, reject) => {
            if (attachmentsValue?.length > 0) {
                let count = 0;
                attachmentsValue?.forEach((attachment: any) => {
                    post_fileUpload({
                        attributeName: "Incidents",
                        attributeId: ticketId,
                        fileName: attachment?.fileName,
                        tabName: "Incidents",
                        userId: auth?.id,
                        createdDate: new Date()
                    })
                        .then(() => {
                            count++;
                            if (count === attachmentsValue.length) {
                                resolve();
                            }
                        })
                        .catch((error) => {
                            console.error('File upload failed:', error);
                            reject(error);
                        });
                });
            } else {
                resolve();
            }
        });
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Create Support Ticket</h2>
                                </div>
                            </div>

                            <div className="mt-2 p-2 w-full">
                                <form
                                    onSubmit={(e) => handleSubmit(e)}
                                >
                                    <div className="w-[60%] px-2">
                                        <div className="w-full">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Subject</label>
                                            <input
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={supportTicketData.incidentName}
                                                onChange={(e) => setSupportTicketData({ ...supportTicketData, incidentName: e.target.value })}
                                                required
                                            />
                                        </div>

                                        <div className="w-full mt-4">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Description</label>
                                            <textarea
                                                className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                rows={6}
                                                value={supportTicketData.description}
                                                onChange={(e) => setSupportTicketData({ ...supportTicketData, description: e.target.value })}
                                            />
                                        </div>

                                        <div className="mt-4 w-full">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Priority</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={supportTicketData.priority}
                                                onChange={(e) => {
                                                    setSupportTicketData({ ...supportTicketData, priority: e.target.value });
                                                }}
                                            >

                                                {
                                                    priorityData.map((item: any, index: number) => {
                                                        return <option key={index} className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                                    })
                                                }

                                            </select>
                                        </div>

                                        <div className='mt-4 w-full'>
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Attachment</label><br />
                                            <Button
                                                key={key}
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color,
                                                    marginTop: "10px"
                                                }}
                                                onClick={() => fileRef.current?.click()}

                                            >
                                                {isDataUploading ? (
                                                    <>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18px"
                                                            className="mr-2 fill-tertiary inline animate-spin"
                                                            viewBox="0 0 26.349 26.35"
                                                        >
                                                            <circle cx="13.792" cy="3.082" r="3.082" />
                                                            <circle cx="13.792" cy="24.501" r="1.849" />
                                                        </svg>
                                                        Processing...
                                                    </>
                                                ) : (
                                                    <div className='flex gap-1.5 items-center'>
                                                        <CloudUploadIcon style={{ color: "#167AC3" }} />
                                                        <span className={`text-sm font-medium`}>Add Attachment</span>
                                                    </div>
                                                )}
                                            </Button>

                                            <input
                                                ref={fileRef}
                                                type="file"
                                                accept="image/png, image/jpeg"
                                                name="image-choose"
                                                style={{ display: 'none' }}
                                                onChangeCapture={onFileChangeCapture}
                                            />
                                        </div>

                                        <div className='w-full flex gap-1.5 mt-4'>
                                            {attachmentsValue?.length !== 0 && (
                                                <div className="flex flex-wrap gap-4 col-span-2">
                                                    {attachmentsValue?.map((_, index) => (
                                                        <div
                                                            key={index}
                                                            className="relative w-40 h-40 group"
                                                            onMouseEnter={(e) => {
                                                                const deleteIcon = e.currentTarget.querySelector('.delete-icon') as HTMLElement;
                                                                if (deleteIcon) deleteIcon.style.visibility = 'visible';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                const deleteIcon = e.currentTarget.querySelector('.delete-icon') as HTMLElement;
                                                                if (deleteIcon) deleteIcon.style.visibility = 'hidden';
                                                            }}
                                                        >
                                                            <div
                                                                className="delete-icon absolute top-1 right-1 bg-slate-200 rounded cursor-pointer"
                                                                style={{ color: "#167AC3", visibility: 'hidden' }}
                                                                onClick={() => deleteImage(index)}
                                                            >
                                                                <DeleteIcon />
                                                            </div>

                                                            <div
                                                                className="w-full h-full rounded-md cursor-pointer"
                                                                onClick={() => viewImage(index)}
                                                            >
                                                                <img
                                                                    className="w-full h-24 rounded-md"
                                                                    src={`${ticketBaseURL}commonFile/Get?name=${_?.fileName}`}
                                                                    alt={_?.fileName}
                                                                />
                                                                <div className="bg-gray-100 w-full mb-4 text-xs flex flex-col justify-center items-center px-3 py-1.5">
                                                                    <span className="font-semibold" style={{ color: "#167AC3" }}>
                                                                        {_?.fileName}
                                                                    </span>
                                                                    <span style={{ color: "#167AC3" }}>
                                                                        {format(new Date(_?.createdDate), 'dd MMM yyyy, hh:mm a')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                    <div className="flex gap-4 mt-8 ml-2">
                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.main.bg
                                            }}
                                            type="submit">
                                            Save
                                        </Button>

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.cancel.bg,
                                                border: colorConfigs.btn.cancel.border,
                                                color: colorConfigs.btn.cancel.color
                                            }}
                                            onClick={() => navigate(-1)}>
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={attachmentsValue}
                fileIndex={fileIndex}
                setFileIndex={setFileIndex}
                imageBaseUrlPath="commonFile"
                isSupportTicket={true}
            />
            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    );
}

export default NewSupportTicket